import React from "react";
import Chart from "react-apexcharts";
import Empty from "../Empty";
import {FormattedMessage} from "react-intl";

export const ChartView = ({
                            options,
                            series,
                            type,
                            width,
                            height,
                            containerClassNames = '',
                          }) => {

  const conditionShowChart = () => {
    switch (type) {
      case 'line':
        return series && series[0].data?.length > 0
      case 'bar':
      default:
        return series && series.length > 0
    }
  };

  return (
    <div className={containerClassNames}>
      {conditionShowChart()
        ?
        (
          <Chart
            options={options}
            series={series}
            type={type}
            width={width}
            height={height}
          />
        )
        :
        (
          <Empty
            customContainerClassname={'py-20 my-8 d-flex justify-content-center align-items-center'}
            message={<FormattedMessage id="no-data" defaultMessage="No data"/>}
          />
        )
      }
    </div>
  )
}